import { Controller } from "@hotwired/stimulus"

// Loading button controller - shows spinner and disables button on click
// Usage: data-controller="loading-button" data-loading-button-text-value="Processando..."
// For file downloads, use: data-action="click->loading-button#download"
export default class extends Controller {
  static values = {
    text: { type: String, default: "Processando..." }
  }

  connect() {
    this.originalContent = this.element.innerHTML
    this.originalWidth = this.element.offsetWidth
  }

  // For normal form submissions / page navigations
  start(event) {
    if (this.element.disabled) {
      event.preventDefault()
      return
    }
    this.showLoading()
  }

  // For file downloads - resets when download completes
  async download(event) {
    event.preventDefault()

    if (this.element.disabled) return

    this.showLoading()

    try {
      const response = await fetch(this.element.href)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const blob = await response.blob()

      // Get filename from Content-Disposition header
      const contentDisposition = response.headers.get('Content-Disposition')
      let filename = 'download.xlsx'
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/)
        if (match) filename = match[1]
      }

      // Create and trigger download
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
      alert('Erro ao exportar. Tente novamente.')
    } finally {
      this.reset()
    }
  }

  showLoading() {
    this.element.style.minWidth = `${this.originalWidth}px`
    this.element.disabled = true
    this.element.classList.add('opacity-75', 'cursor-not-allowed')

    this.element.innerHTML = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      ${this.textValue}
    `
  }

  reset() {
    this.element.disabled = false
    this.element.classList.remove('opacity-75', 'cursor-not-allowed')
    this.element.innerHTML = this.originalContent
    this.element.style.minWidth = ''
  }
}
